module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAO0lEQVQ4y2NgGHbgPxTjY+PWDAP42PgM+k8IwNRQZAg+A/5TYsB/UgBFBtDM/0QZQkxawGsI3QygLwAAbjZlqS88cqkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/assets/images/grabbing.png
// module id = ../../../../../src/assets/images/grabbing.png
// module chunks = styles